import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup } from '@telus-uds/components-web';

import Label from './common/label';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const DefectWebform = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const {
    reportAnIssue: {
      form: {
        labelDefectWebform,
        labelDefectWebformOptionBusinessConnect,
        labelDefectWebformOptionWirelineSecurity,
        labelDefectWebformOptionWireless,
        labelDefectWebformOptionMyod,
        labelDefectWebformOptionPhoneNumberCheck,
        labelDefectWebformOptionContactCentre,
        labelDefectWebformOptionReferralTool,
        labelDefectWebformOptionInternetOfThings,
        labelDefectWebformOptionBusinessApps,
        labelDefectWebformOptionFullyManaged,
        labelDefectWebformOptionVulcanWebform
      }
    }
  } = useLocalizedStringsContext();

  const fieldError = 'defectWebform' in formErrors;
  const fieldOptions = [
    labelDefectWebformOptionBusinessConnect,
    labelDefectWebformOptionWirelineSecurity,
    labelDefectWebformOptionWireless,
    labelDefectWebformOptionMyod,
    labelDefectWebformOptionPhoneNumberCheck,
    labelDefectWebformOptionContactCentre,
    labelDefectWebformOptionReferralTool,
    labelDefectWebformOptionInternetOfThings,
    labelDefectWebformOptionBusinessApps,
    labelDefectWebformOptionFullyManaged,
    labelDefectWebformOptionVulcanWebform
  ];

  const handleSelect = (value) => {
    if (value)
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.defectWebform;
        return updatedValues;
      });
    setFieldData(previousValue => ({
      ...previousValue,
      defectWebform: value
    }));
  };

  // Convert options to RadioGroup items format
  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <div>
      <Label labelName={`${labelDefectWebform} *`} />
      <RadioGroup
        items={radioItems}
        checkedId={fieldData.defectWebform || null}
        onChange={handleSelect}
        name="defectWebform"
        validation={fieldError ? 'error' : undefined}
        feedback={fieldError ? formErrors.defectWebform.message : undefined}
      />
    </div>
  );
};

DefectWebform.propTypes = {
  formErrors: PropTypes.shape({
    defectWebform: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectWebform;
